<template>
  <div class="echart" ref="echart" :style="echartStyle"></div>
</template>

<script>
import echart from "@/utils/echart";
export default {
  props: {
    echartStyle: {
      type: Object,
      default() {
        return { 
          width: '100%',
          height: '300px'
         };
      },
    },
    largeList: {
      type: Array,
      default() {
        return [];
      },
    },
    isScale: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    options() {
      return {
        tooltip: {
          // trigger: 'axis',
          // axisPointer: {
          //   type: 'shadow'
          // }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.largeList.map(v=>v.dateTime),
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        dataZoom: {
          type: 'inside',
          start: 0,
          end: ((window.innerWidth == 1920 ? 16 : 10)/this.largeList.length)*100
        },
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: '20%',
            data: this.largeList.map(v=>v.total),
            itemStyle: {
              color: "#24c69a",
            },
          }
        ]
      }
    },
    dataList() {
      return this.chatsList
    }
  },
  watch: {
    options: {
      handler() {
        this.init()
      },
      deep: true
    }
    
  },
  data() {
    return {
    };
  },
  methods: {
    init(data) {
      const divFef = this.$refs.echart;
      const { setData } = echart(divFef);
      setData(this.options);
    },
  },
  mounted() {
  },
};
</script>

<style lang="stylus" scoped></style>
